import { Flex, Button, Text } from "@chakra-ui/react"
import { CloseIcon } from "@chakra-ui/icons"
import PropTypes from "prop-types";
import { toggleSelectedRegion } from "../../utils/helpers";

export const SelectedRegionBar = (props) => {

    const { regions, selectedRegions, setSelectedRegions } = props

    if (selectedRegions.length === 0) {
        return null;
    }

    return (
        <Flex justifyContent={'flex-start'} overflowX={'auto'} pb={3}>
            {selectedRegions?.map((region, index) =>
                <Button key={index} backgroundColor={'gray.100'} color={'gray.600'} _hover={{ bg: '' }} _active={{ bg: '' }} mr={2} flexShrink={0}>
                    <Text fontWeight={700}>{regions.find((r) => r.id === region)?.name}</Text>
                    <CloseIcon boxSize={2} ml={5} onClick={() => toggleSelectedRegion(region, selectedRegions, setSelectedRegions)} />
                </Button>
            )}
        </Flex>
    )
}


SelectedRegionBar.propTypes = {
    regions: PropTypes.array,
    toggleSelectedRegion: PropTypes.func,
    selectedRegions: PropTypes.array,
}

SelectedRegionBar.defaultProps = {
    regions: [],
    toggleSelectedRegion: () => { },
    selectedRegions: [],
}